import { CheckCircle2, AlertTriangle } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import type { IntegridadResult as IntegridadResultType } from './api';

interface IntegridadResultProps {
  result: IntegridadResultType;
}

export function IntegridadResult({ result }: IntegridadResultProps) {
  if (result.valid) {
    return (
      <Card>
        <CardContent className="flex items-center gap-4 p-6">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[var(--color-moss-50)] text-[var(--color-moss)]">
            <CheckCircle2 className="h-6 w-6" />
          </div>
          <div>
            <p className="font-display text-lg font-semibold text-[var(--color-moss)]">
              Cadena integra
            </p>
            <p className="mt-0.5 text-sm text-[var(--color-ink-muted)]">
              {result.totalMovimientos} movimiento{result.totalMovimientos !== 1 ? 's' : ''} verificado{result.totalMovimientos !== 1 ? 's' : ''} correctamente.
              Cumplimiento Ley 21.442 Art. 7.
            </p>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="border-[var(--color-danger)]">
      <CardContent className="p-6">
        <div className="flex items-center gap-4">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[var(--color-danger-50)] text-[var(--color-danger)]">
            <AlertTriangle className="h-6 w-6" />
          </div>
          <div>
            <p className="font-display text-lg font-semibold text-[var(--color-danger)]">
              Cadena con inconsistencias
            </p>
            <p className="mt-0.5 text-sm text-[var(--color-ink-muted)]">
              Se encontraron {result.errors.length} error{result.errors.length !== 1 ? 'es' : ''} en {result.totalMovimientos} movimiento{result.totalMovimientos !== 1 ? 's' : ''}.
            </p>
          </div>
        </div>

        <ul className="mt-4 space-y-2 border-t border-[var(--color-hairline)] pt-4">
          {result.errors.map((err, i) => (
            <li
              key={i}
              className="flex items-start gap-2 rounded bg-[var(--color-danger-50)] p-3 text-sm"
            >
              <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-[var(--color-danger)]" />
              <div>
                <p className="font-medium text-[var(--color-ink)]">
                  Movimiento #{err.indice + 1} ({err.movimientoId.slice(0, 8)}...)
                </p>
                <p className="text-[var(--color-ink-muted)]">{err.error}</p>
              </div>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
}
